this.discounts = undefined;
this.menuType = undefined;
this.originalSellPrice = undefined;

const verifyMenuMode = (settings) => {
  const menuMode = this.menuType;
  if (menuMode === 'ONLINE_MENU' && settings.isMenu) {
    return true;
  }
  if (menuMode === 'SELF_SERVICE_KIOSK' && settings.isKiosk) {
    return true;
  }
  if (menuMode === 'PAYMENT_KIOSK' && settings.isKiosk) {
    return true;
  }
  return false;
};

const getDiscounts = () => this.discounts.filter(
  (d) => {
    if (d.displaySettings) {
      const settings = parseDisplaySettings(d.displaySettings);
      return !!(settings && settings.isDisplay && verifyMenuMode(settings));
    }
    return false;
  },
);

const parseDisplaySettings = (displaySettingsJsonString) => {
  if (!displaySettingsJsonString) {
    return undefined;
  }
  return JSON.parse(displaySettingsJsonString);
};

const getDisplaySettings = discount => parseDisplaySettings(discount.displaySettings);

const getSum = (discounts, discountType) => {
  return discounts.filter(d => d.discountType === discountType).reduce((acc, d) => {
    acc += d.amount;
    return acc;
  }, 0);
};

const getMethod = () => {
  const discounts = getDiscounts();
  const percentValue = getSum(discounts, 'PERCENT');
  let dollarValue = 0.0;
  dollarValue += getSum(discounts, 'DOLLAR');
  dollarValue += getSum(discounts, 'COST');
  if (percentValue > 0 && dollarValue > 0) {
    return '$';
  }
  if (dollarValue > 0) {
    return '$';
  }
  if (percentValue > 0) {
    return '%';
  }
  return '';
}

const getCalDiscount = () => {
  const discounts = getDiscounts();
  if (!discounts.length) {
    return undefined;
  }
  let sum = 0;
  sum += getSum(discounts, 'DOLLAR');
  sum += getSum(discounts, 'COST');
  const percentValue = getSum(discounts, 'PERCENT');

  if (sum > 0 && percentValue > 0) {
    let dollarValue = 0;
    if (percentValue > 0) {
      dollarValue = (this.originalSellPrice / 100) * percentValue;
    }
    sum += dollarValue;
  }

  if (sum === 0 && percentValue > 0) {
    return {
      discount: percentValue,
      discountAmount: (this.originalSellPrice / 100) * percentValue,
    };
  }
  return {
    discount: sum,
    discountAmount: sum,
  };
};

const getDiscountAmount = () => getCalDiscount().discount;

const getText = method => {
  if (method === '$') {
    return `-${getMethod()}${getDiscountAmount()}`;
  } else {
    return `-${getDiscountAmount()}${getMethod()}`;
  }
}

const getColor = () => {
  const discounts = getDiscounts();
  if (discounts) {
    return getDisplaySettings(getDiscounts()[0]).textColor;
  }
  return undefined;
};

const getBgColor = () => {
  const discounts = getDiscounts();
  if (discounts) {
    return getDisplaySettings(getDiscounts()[0]).bannerColor;
  }
  return undefined;
};

// eslint-disable-next-line import/prefer-default-export
export const getDiscount = (discounts, originalSellPrice, menuType) => {
  if (!discounts || !discounts.length) {
    return undefined;
  }
  this.discounts = discounts;
  this.menuType = menuType;
  this.originalSellPrice = parseFloat(originalSellPrice) || 0.0;
  const caclDiscount = getCalDiscount();
  if (!caclDiscount) {
    return undefined;
  }
  const method = getMethod();
  return {
    discountPrice: this.originalSellPrice - caclDiscount.discountAmount,
    discountAmount: caclDiscount.discountAmount,
    amount: caclDiscount.discount, // view
    method,
    textColor: getColor(),
    bannerColor: getBgColor(),
    text: getText(method),
    getDiscountPrice: function(originalPrice) {
      if (this.method === '%') {
        return originalPrice - (originalPrice / 100 * this.amount);
      }
      return originalPrice - this.amount;
    },
  };
};



// WEBPACK FOOTER //
// ./src/helpers/discountUtils.js